<template>
  <v-app>
    <!-- Agricultura Navigation -->
    <fh-agro-nav-drawer
      v-if="!isRestrictedView && this.currentCategoria === 1"
      :drawer="drawer"
    ></fh-agro-nav-drawer>

    <!-- Ganadería Navigation -->
    <fh-ganaderia-nav-drawer
      v-if="!isRestrictedView && this.currentCategoria === 2"
      :drawer="drawer"
    ></fh-ganaderia-nav-drawer>

    <!-- Navigation drawer for content indexes -->
    <fh-content-drawer
      :drawer="contentDrawer"
      :contentList="listaContenidos"
    ></fh-content-drawer>

    <!-- Navigation drawer for content index in Admin -->
    <v-app-bar app clipped-left clipped-right extended extension-height="0">
      <v-app-bar-nav-icon
        :disabled="isRestrictedView"
        @click.stop="handleMenuIconClick"
      ></v-app-bar-nav-icon>
      <fh-switch-categoria :mobile="mobile"></fh-switch-categoria>
      <v-spacer></v-spacer>
      <fh-menu-temporada
        v-show="!isRestrictedView && isAgricultorSet"
      ></fh-menu-temporada>
      <fh-menu-agricultor v-if="!isOnlyOperador"></fh-menu-agricultor>
      <fh-menu-operador></fh-menu-operador>

      <fh-progress slot="extension"></fh-progress>
    </v-app-bar>

    <v-main>
      <fh-acceso-anterior />
      <v-fade-transition hide-on-leave>
        <router-view :key="fichaAgricola.idFichaAgricola" />
      </v-fade-transition>
    </v-main>

    <v-bottom-navigation
      v-if="mobile && isEstablecimientoSet"
      app
      light
      grow
      color="green"
    >
      <v-btn
        v-if="hasCategoriaAgricultura"
        @click="handleAgroClick"
        :class="colorAgro"
        small
      >
        <span>Agro</span>
        <v-icon>fa-seedling</v-icon>
      </v-btn>

      <v-btn
        v-if="hasCategoriaGanaderia"
        @click="handleGanaderiaClick"
        :class="colorGanaderia"
        small
      >
        <span>Ganadería</span>
        <v-icon>{{ cowIcon }}</v-icon>
      </v-btn>
      <v-btn class="ml-1" @click="handleEstConfClick" small>
        <v-badge
          v-if="parcelas.length === 0 && currentCategoria === 2"
          color="error"
          dot
          ><v-icon :color="colorConf" small>fa-cogs</v-icon></v-badge
        >
        <v-icon v-else :color="colorConf">fa-cogs</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <fh-snackbar></fh-snackbar>
  </v-app>
</template>

<script>
import FhProgress from "@/components/app/FhProgress";
import FhSnackbar from "@/components/app/FhSnackbar";
import FhMenuAgricultor from "@/components/app/FhMenuAgricultor";
import FhMenuOperador from "@/components/app/FhMenuOperador";
import FhMenuTemporada from "@/components/app/FhMenuTemporada";
import { mapActions, mapGetters, mapState } from "vuex";
import FhAccesoAnterior from "@/components/app/FhAccesoAnterior";
import SessionService from "@/services/SessionService";
import FhSwitchCategoria from "@/components/app/FhSwitchCategoria.vue";
import { mdiCow } from "@mdi/js";
import { GlobalEventEmitter } from "@/GlobalEventEmitter";
import FhAgroNavDrawer from "@/components/app/FhAgroNavDrawer.vue";
import FhGanaderiaNavDrawer from "@/components/app/FhGanaderiaNavDrawer.vue";
import FhContentDrawer from "@/components/app/FhContentDrawer.vue";

export default {
  name: "App",
  components: {
    FhMenuTemporada,
    FhMenuOperador,
    FhMenuAgricultor,
    FhSnackbar,
    FhProgress,
    FhAccesoAnterior,
    FhSwitchCategoria,
    FhAgroNavDrawer,
    FhGanaderiaNavDrawer,
    FhContentDrawer,
  },
  data() {
    return {
      drawer: true,
      mobile: window.innerWidth <= 700,
      cowIcon: mdiCow,
      breadcrumb: "",
      adminGanaderia: false,
      contentDrawer: false,
      listaContenidos: [],
    };
  },
  computed: {
    ...mapState("fichas", ["fichaAgricola", "parcelas"]),
    ...mapState("conceptos", ["conceptos"]),
    ...mapState("session", ["isRestored"]),
    ...mapState("admin", ["esAdmin"]),
    ...mapGetters("temporada", ["isTemporadaSet"]),
    ...mapGetters("establecimientos", [
      "isEstablecimientoSet",
      "currentCategoria",
      "hasCategoriaAgricultura",
      "hasCategoriaGanaderia",
    ]),
    ...mapGetters("agricultor", ["isOnlyOperador", "isAgricultorSet"]),
    ...mapState("establecimientos", ["establecimiento"]),
    isRestrictedView() {
      return (
        this.$route.name === "ElegirAgricultor" ||
        this.$route.name === "CrearEstablecimiento" ||
        this.$route.name === "Privacy"
      );
    },
    fechaHoraAccesoAnterior() {
      return SessionService.getFechaHoraAccesoAnterior();
    },
    colorAgro() {
      //  || this.$route.path.includes('/agro')
      return this.currentCategoria === 1 ? "v-btn--active" : "no-active";
    },
    colorGanaderia() {
      return this.currentCategoria === 2 ? "v-btn--active" : "no-active";
    },
    colorConf() {
      return this.$route.name === "ConfiguracionEstablecimientos"
        ? "primary"
        : "grey darken-2";
    },
  },
  methods: {
    ...mapActions("rubros", ["fetchListaRubro"]),
    ...mapActions("admin", ["fetchEsAdmin"]),
    ...mapActions("establecimientos", ["changeGrupoExplotacion"]),
    ...mapActions("conceptos", [
      "fetchListaConceptos",
      "fetchListaSubConceptos",
    ]),
    handleMenuIconClick() {
      if (!this.isRestrictedView) {
        this.drawer = !this.drawer;
      }
    },
    handleAgroClick() {
      if (this.currentCategoria !== 1) {
        this.changeGrupoExplotacion();
      }
      this.$router.push({ name: "AgroHome" }).catch(() => {});
    },
    handleGanaderiaClick() {
      if (this.currentCategoria !== 2) {
        this.changeGrupoExplotacion();
      }
      this.$router.push({ name: "GanaderiaHome" }).catch(() => {});
    },
    handleTitleClick() {
      this.$router.push({ name: "AgroHome" }).catch(() => {});
    },
    handleEstConfClick() {
      this.$router
        .push({ name: "ConfiguracionEstablecimientos" })
        .catch(() => {});
    },
  },
  watch: {
    $route(to, from) {
      if (
        to.matched.some(
          (route) =>
            route.name === "Estadisticas" ||
            route.name === "EstadisticasGanaderia" ||
            route.name === "ResumenMovimientos" ||
            this.mobile
        )
      ) {
        this.drawer = false;
      }
    },
  },
  async created() {
    // To prevent a race condition when session isn't restored yet
    while (!this.isRestored) {
      await this.$sleep(10);
    }
    await this.fetchEsAdmin();

    await this.fetchListaConceptos();
    await this.fetchListaSubConceptos();

    addEventListener("resize", () => {
      this.mobile = innerWidth <= 700;
    });

    GlobalEventEmitter.$on("admin-ganaderia", (data) => {
      if (Array.isArray(data) && data.length !== 0) {
        this.listaContenidos = data;
        this.contentDrawer = true;
      } else {
        this.contentDrawer = false;
      }
    });
    GlobalEventEmitter.$on("admin-agricultura", () => {
      this.adminGanaderia = false;
    });
    GlobalEventEmitter.$on("content-drawer", (data) => {
      if (Array.isArray(data) && data.length !== 0) {
        this.listaContenidos = data;
        this.contentDrawer = true;
      } else {
        this.contentDrawer = false;
      }
    });
  },
  beforeDestroy() {
    // removes event listener
    GlobalEventEmitter.$off("admin-ganaderia");
    GlobalEventEmitter.$off("admin-agricultura");
    GlobalEventEmitter.$off("content-drawer");
  },
};
</script>

<style scoped>
/* Extend progress indicator over whole toolbar */
/*noinspection CssUnusedSymbol*/
.v-toolbar :deep() .v-toolbar__extension {
  padding: 0;
}

/* Make toolbar title look clickable */
.fh-cursor-pointer {
  cursor: pointer;
}
.fh-icon {
  height: 24px;
}
.fh-icon-small {
  height: 16px;
}
</style>
<style scoped>
.v-btn--active.no-active:not(:focus):not(:hover)::before {
  opacity: 0 !important;
}
</style>
